import { defHttp } from "../utils/http/axios";

const Api = {
  getProject: "/cat/tasker/project/detail",
  getTaskItem: "/cat/tasker/project/task/detail",
  getFileBriefInfo: "/cat/tasker/project/file/brief",
  getFileSentences: "/cat/tasker/project/file/sentence/list",
  getTaskSentences: "/cat/tasker/project/task/sentence",

  /**
   * note
   */
  listNotes: "/cat/project/file/sentence/note/list",
  saveNote: "/cat/project/file/sentence/note/save",
  deleteNote: "/cat/project/file/sentence/note/delete",

  /**
   * history
   */
  listHistory: "/cat/project/file/sentence/history/list",

  /**
   * tm
   */
  getTmMatches: "/cat/project/tm/match",

  /**
   * file preview
   */
  getFileSourcePreview: "/cat/project/file/preview/src",

  /**
   * qa check
   */
  toggleQaIssueState: "/cat/project/file/sentence/issue/ignore",

  checkTick: "/cat/tasker/sentence/check",
  getSentenceStatusAndQA: "/cat/tasker/sentence/status",
  getSentenceLog: "/cat/tasker/sentence/log",

  getMTMatches: "/cat/tasker/sentence/mt",
  getTBmatches: "/cat/tasker/sentence/tb",
  getPolishResult: "/cat/tasker/sentence/polish"
}

export function checkTick() {
  return defHttp.get({ url: Api.checkTick });
}

  /**
   * 获取项目详情
   * @param {String} id
   * @returns
   */
  export function getProjectDetailForEditor(params) {
    return defHttp.get({ url: Api.getProject, params });
  }

  /**
   * 获取翻译任务详情
   * @param {String} id
   * @returns
   */
  export function getTaskInfo(params) {
    return defHttp.get({ url: Api.getTaskItem, params });
  }

  /**
   * 获取文件简略信息
   * @param {String} fileId
   * @returns
   */
  export function getFileBriefInfo(params) {
    return defHttp.get({ url: Api.getFileBriefInfo, params });
  }

  /**
   * 获取句子
   * @param form
   * @returns
   */
  export function getTaskSentences(form) {
    return defHttp.post({ url: Api.getTaskSentences, data: form });
  }

  /**
   * 获取任务文件句子分页
   * @param form
   * @returns
   */
  export function getFileSentencesForEditor(data) {
    return defHttp.post({ url: Api.getFileSentences, data });
  }

  /**
   * 刷新句子的状态(包括QA)
   * @param {String} sentenceId
   * @returns
   */
  export function getSentenceStatusAndQA(ids) {
    return defHttp.post({ url: Api.getSentenceStatusAndQA, data: { ids } });
  }

  /**
   * 获取某一句段对应的日志
   * @param {String} id - 翻译单元 id
   * @returns
   */
  export function getSentenceLog(id) {
    return defHttp.get({ url: Api.getSentenceLog, params: { id } });
  }

  /**
   * 获取某一句段对应的 TM 匹配
   * @param {String} tuId
   * @returns
   */
  export function queryTMEntryMatch(data) {
    return defHttp.postWithCancel({ url: Api.getTmMatches, data });
  }

  /**
   * 获取机器翻译
   * @param {Object} form
   * @returns
   */
  export function getMTMatches(form) {
    return defHttp.post({ url: Api.getMTMatches, data: form });
  }

  /**
   * 获取某一句段对应的 TB 匹配
   * @param {String} tuId
   * @returns
   */
  export function getTBmatches(form) {
    return defHttp.post({ url: Api.getTBmatches, data: form });
  }

  /**
   * 获取某一句段对应的自动润色结果
   * @param {*} form
   */
  export function getPolishResult(form) {
    return defHttp.post({ url: Api.getPolishResult, data: form });
  }

  /**
   * 获取翻译单元备注
   * @param params - 翻译单元 ID
   * @returns
   */
  export function getNotes(params) {
    return defHttp.get({ url: Api.listNotes, params });
  }

  /**
   * 保存备注
   * @param {Object} data
   * @returns
   */
  export function saveNote(data) {
    return defHttp.post({ url: Api.saveNote, data });
  }
  /**
   * 删除备注
   * @param {String} id - 备注 ID
   * @returns
   */
  export function deleteNote(data) {
    return defHttp.post({ url: Api.deleteNote, data });
  }

  /**
   * 获取翻译单元历史
   * @param {String} id - 翻译单元 ID
   * @returns
   */
  export function getHistoryList(params) {
    return defHttp.get({ url: Api.listHistory, params });
  }

  /**
   * 保存句段
   * @param {Object} form
   * @param {String} form.projectId
   * @param {Number} form.taskType
   * @param {Array} form.sentences
   * @returns
   */
  export function saveSentences(form) {
    return defHttp.post({ url: Api.saveSentences, data: form });
  }

  /**
   * 确认句段
   * @param {Object} form
   */
  export function confirmSentence(form) {
    return defHttp.post({ url: Api.confirmSentence, data: form });
  }

  /**
   * 拒绝句段
   * @param {Object} form
   * @returns
   */
  export function rejectSentence(form) {
    return defHttp.post({ url: Api.rejectSentence, data: form });
  }

  /**
   * 对当前句子进行QA检查
   * @param {{sentenceId:String}} form
   * @returns
   */
  export function checkSentenceQA(form) {
    return defHttp.post({ url: Api.checkSentenceQA, data: form });
  }

  /**
   * 切换QA issue状态
   * @param {Object} toggleForm
   * @returns
   */
  export function toggleQaIssueState(toggleForm) {
    return defHttp.post({ url: Api.toggleQaIssueState, data: toggleForm });
  }

  /**
   * 获取译文润色要求的初始化列表
   * @returns
   */
  export function getTranslationPolishStyles() {
    return defHttp.get({ url: Api.getTranslationPolishStyles });
  }

  /**
   * 获取用户选择的默认润色要求
   * @returns
   */
  export function getPolishDefaultSettings() {
    return defHttp.get({ url: Api.getPolishDefaultSettings });
  }

  /**
   * 获取原文预览(带格式)
   * @param {Number} fileId
   * @returns
   */
  export function getFileSourcePreview(params){
    return defHttp.get({ url: Api.getFileSourcePreview, params });
  }
